const config = {
  production: false,
  development: false,

  api: 'https://api.partner.bahnkick.com/lessor/staging/ql',

  publicApiRoot: 'https://bahnkick-dev-api.azurewebsites.net/api',

  signalRHubUrl: 'https://bahnkick-dev-signalr.azurewebsites.net/api',

  LOG_ROCKET_KEY: '8kox0k/bahnkick-lessor-dev',
};

export default config;
